import { setWildCardCookie } from "~/utils/cookie-util";


const detectminiprogram = () => {
    if (navigator.userAgent.indexOf("MiniProgram") > -1 || navigator.userAgent.indexOf("AliApp") > -1) {
        setWildCardCookie("miniApp","mpesa" , 1825);
    }
}

export default detectminiprogram ;